import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ProductEntity } from '@cjm/shared/types';
import { CJMContentComponent } from '@cjm/shared/ui/common';

import { ProductGridItemComponent } from '../product-grid-item/product-grid-item.component';

@Component({
	selector: 'vloket-product-grid',
	templateUrl: './product-grid.component.html',
	styleUrls: ['./product-grid.component.scss'],
	host: {
		'[class.c-product-grid]': 'true'
	},
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CJMContentComponent, ProductGridItemComponent]
})
export class ProductGridComponent {
	@Input() public products: ProductEntity[] = [];
	@Input() public loading: boolean = false;
	@Input() public error: boolean = false;
	@Input() public hasFavouriteButton: boolean = false;
	@Input() public actionInProgress: string | number = null;

	/**
	 * setItemAsFavoriteClicked will emit an event when the "set as Favorite" button on an individual item is clicked.
	 */
	@Output() public setItemAsFavoriteClicked: EventEmitter<string | number> = new EventEmitter<string | number>();
	/**
	 * removeItemAsFavoriteClicked will emit an event when the "remove as Favorite" button on an individual item is clicked.
	 */
	@Output() public removeItemAsFavoriteClicked: EventEmitter<string | number> = new EventEmitter<string | number>();
}
